<template>
  <div class="yxtbiz-signup-my pb24 bc-cCF5">
    <div class="flex space-between w1200 mt24 align-left">
      <div class="w100p bc-cCFF">
        <div class="mt24 ml32 mr32 mb32">
          <div class="fs24 mb24">{{language().tit_my}}</div>
          <div class="bc-cCFA rtl4 rtr4 rbl4 rbr4 pt24 pl24 pr24 pb24">
            <div class="mb12 fw500 fs20 ellipsis lineClamp2 word-break">
              <yxtf-tag class="pl7 pr7 fs14 relative top-1" coverType="blue" size="small" type="info">{{data.appName}}</yxtf-tag>
              <span :title="data.projectName">{{data.projectName}}</span>
            </div>
            <div class="flex space-between rtl4 rtr4 rbl4 rbr4">
              <div class="w50p-12">
                <div class="mb8 c-cC8C relative">
                  <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_admin}}</span>
                  <span class="absolute top0 left58">：</span>
                  <span class="c-cC26 block pl70">
                    <yxtbiz-user-name slot="content" :name="(data.owners || []).map(_ => _.fullname).join('、') || '--'" split="、" />
                  </span>
                </div>
                <div v-for="(info, index) in extendedInfo" :key="index" :class="`c-cC8C relative ${index ? 'mt8' : ''}`">
                  <span class="absolute top0 inline-block w58 justify ellipsis">{{info.label}}</span>
                  <span class="absolute top0 left58">：</span>
                  <span class="c-cC26 block pl70">{{info.value || '--'}}</span>
                </div>
              </div>
              <div class="w50p-12 align-right flex-end" v-if="data.pointPrice">
                <div>
                  <div class="mb8 c-cC8C relative">
                    <span class="inline-block">{{language().lbl_total_cost}}</span>
                    <span class="inline-block">：</span>
                    <span class="inline-block c-cC26">
                      <img class="d-integral relative top-5" :src="`${$staticBaseUrl}assets/141df7bc/85e5b524/a27406.svg`" alt="" />
                      <span class="ml4 c-cC26 fs24 fw500">{{data.pointPrice}}</span>
                      <span class="ml4 c-cC75 relative top-3">{{language().msg_integral}}</span>
                    </span>
                  </div>
                  <div class="c-cC8C relative" v-if="points.totalMallPoint">
                    <span class="inline-block">{{language().lbl_available_points}}</span>
                    <span class="inline-block">：</span>
                    <span class="inline-block c-cC26">{{points.totalMallPoint.toLocaleString()}}</span>
                  </div>
                </div>
              </div>
              <div class="w50p-12 align-right flex-end" v-else>
                <div class="c-cC8C relative top-2">
                  <span class="inline-block">{{language().lbl_total_cost}}</span>
                  <span class="inline-block">：</span>
                  <span class="inline-block c-cC59 fw500 fs20">{{language().msg_free}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="ml24 mt24 inline-block" v-if="!data.userOtherEnrolled">
            <template v-if="[0, 1, 2, 5].includes(info.auditStatus)">
              <div class="mb15 c-cC8C relative h24" v-if="info.orderCode && data.pointPrice">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_order_number}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70">{{info.orderCode}}</span>
              </div>
              <div class="mb15 c-cC8C relative h24" v-if="info.orderCreateTime && data.pointPrice">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_creation_time}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70">{{info.orderCreateTime}}</span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_registration_status}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70">
                  <span :class="`fw500 fs16 ${info.auditStatus === 2 ? 'c-cCRed' : info.auditStatus === 0 ? 'c-cCOrange' : ''}`">{{ $parent.auditStatusObj[info.auditStatus].label || '' }}</span>
                  <span class="c-cC75" v-if="$parent.auditStatusObj[info.auditStatus].info">（{{ $parent.auditStatusObj[info.auditStatus].info || '' }}）</span>
                </span>
              </div>
              <div class="mb15 c-cC8C relative h24" v-if="info.auditStatus === 5">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_alternate_position}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70" v-if="info.substituteOrder">{{language().msg_alternate_position.replace('$num', info.substituteOrder)}}</span>
              </div>
            </template>
            <template v-else-if="[3].includes(info.auditStatus)">
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_registration_status}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cCRed block pl70">
                  <span class="fw500 fs16">{{$parent.auditStatusObj[info.auditStatus].label || ''}}</span>
                </span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_abandoner}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70" v-if="info.fullname">
                  <span class="mr24">
                    <yxtf-portrait size="small" class="h24 wh24" :imgUrl="info.imgUrl" :username="info.fullname"></yxtf-portrait>
                    <span class="relative top-6 ml4">
                      <yxtbiz-user-name slot="content" :name="info.fullname" />
                    </span>
                  </span>
                </span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_give_up_time}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70" v-if="info.actionTime && info.auditStatus === 3">{{info.actionTime}}</span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_reasons}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70" v-if="info.reason">{{info.reason}}</span>
              </div>
            </template>
            <template v-else-if="[4].includes(info.auditStatus)">
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_registration_status}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cCRed block pl70">
                  <span class="fw500 fs16">{{$parent.auditStatusObj[info.auditStatus].label || ''}}</span>
                </span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_operator || ''}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70">
                  <span class="mr24">
                    <yxtf-portrait size="small" class="h24 wh24" :imgUrl="info.optGiveUpUserImgUrl" :username="info.optGiveUpUserfullname"></yxtf-portrait>
                    <span class="relative top-6 ml4">
                      <yxtbiz-user-name :name="info.optGiveUpUserfullname" />
                    </span>
                  </span>
                </span>
              </div>
              <div class="mb15 c-cC8C relative h24">
                <span class="absolute top0 inline-block w58 justify ellipsis">{{language().lbl_operation_time}}</span>
                <span class="absolute top0 left58">：</span>
                <span class="c-cC26 block pl70" v-if="info.actionTime">{{info.actionTime}}</span>
              </div>
            </template>
          </div>
          <template v-else>
            <div class="ml24 mt24">
              <yxtf-select class="w180" v-model="auditValue" clearable :placeholder="language().lbl_registration_status" @change="searchPage">
                <yxtf-option
                  v-for="(item, index) in $parent.auditStatus"
                  :key="index"
                  :label="item.label + (item.info ? `（${item.info}）` : '')"
                  :value="item.value"
                >
                </yxtf-option>
              </yxtf-select>
            </div>
            <div class="ml24 mt24">
              <yxtf-table class="w100p table-cell-right12" :data="list">
                <yxtf-table-column :label="language().lbl_registrants">
                  <template slot-scope="scope">
                    <yxtbiz-user-name :name="scope.row.fullname || '--'" />
                  </template>
                </yxtf-table-column>
                <yxtf-table-column :label="language().lbl_registration_method">
                  <template slot-scope="scope">
                    <span>{{($parent.enrollTypeObj[scope.row.enrollType] || {}).label || '--'}}</span>
                  </template>
                </yxtf-table-column>
                <yxtf-table-column :label="language().lbl_registration_status" width="275">
                  <template slot-scope="scope">
                    <span :class="[scope.row.auditStatus === 1 || scope.row.auditStatus === 5 ? 'bc-cCGreen' : scope.row.auditStatus === 0 ? 'bc-cCOrange' : 'bc-cCD8', 'relative top-2 dot']"></span>
                    <span class="mr4">{{(($parent.auditStatusObj[scope.row.auditStatus] || {}).label || '') + (($parent.auditStatusObj[scope.row.auditStatus] || {}).info ? `（${$parent.auditStatusObj[scope.row.auditStatus].info}）` : '')}}</span>
                    <yxtf-popover
                      v-if="scope.row.auditStatus === 3 || scope.row.auditStatus === 4"
                      placement="top"
                      :title="scope.row.auditStatus === 3 ? language().lbl_y_give_up : language().lbl_disqualified"
                      :width="260"
                      trigger="hover"
                      :visible-arrow="true"
                    >
                      <yxtf-svg class="relative top4 c-cC8C" slot="reference" width="18px" height="18px" icon-class="prompt-0" />
                      <div class="yxtbiz-signup">
                        <div class="mah100" v-if="scope.row.auditStatus === 3">
                          <div class="c-cC8C relative h24 ellipsis">
                            {{language().lbl_abandoner}}：
                            <span class="c-cC26">
                              <yxtbiz-user-name :name="scope.row.optGiveUpUserfullname || '--'" />
                            </span>
                          </div>
                          <div class="c-cC8C relative h24">
                            {{language().lbl_give_up_time}}：<span class="c-cC26">{{scope.row.actionTime}}</span>
                          </div>
                          <div class="c-cC8C relative h241">
                            {{language().lbl_reasons}}：<span class="c-cC26">{{scope.row.reason}}</span>
                          </div>
                        </div>
                        <div class="mah100" v-else>
                          <div class="c-cC8C relative h24 ellipsis">
                            {{language().lbl_operator}}：<span class="c-cC26"><yxtbiz-user-name :name="scope.row.optGiveUpUserfullname" /></span>
                          </div>
                          <div class="c-cC8C relative h24">
                            {{language().lbl_operation_time}}：<span class="c-cC26">{{scope.row.actionTime}}</span>
                          </div>
                        </div>
                      </div>
                    </yxtf-popover>
                  </template>
                </yxtf-table-column>
                <yxtf-table-column :label="language().lbl_abandoner" v-if="isShowAbandoner">
                  <template slot-scope="scope">
                    <yxtbiz-user-name :name="scope.row.optGiveUpUserfullname || '--'" />
                  </template>
                </yxtf-table-column>
                <yxtf-table-column :label="language().lbl_operation" width="124">
                  <template slot-scope="scope">
                    <span :class="`fs14 ${factor ? 'pointer c-cC436BFF' : 'not-allowed c-cCBF'}`" v-if="[0, 1, 5].includes(scope.row.auditStatus) && timeValue < (new Date(data.giveUpDeadline)).valueOf()" @click="cancel(scope.row.id)">{{language().btn_give_up}}</span>
                  </template>
                </yxtf-table-column>
              </yxtf-table>
            </div>
            <yxtf-pagination class="mt24 align-right" layout="prev, pager, next" :current-page.sync="current" :total="total" :page-size="size" @current-change="search"></yxtf-pagination>
          </template>
          <div class="ml24 mt32 center">
            <yxtf-button size="larger2" :disabled="!factor" @click.stop="cancel()" v-if="!data.userOtherEnrolled && [0, 1, 5].includes(info.auditStatus) && timeValue < (new Date((data.giveUpDeadline || '').replace(/-/g, '/'))).valueOf()">{{language().btn_give_up}}</yxtf-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YxtbizSignupOrder',
  inject: ['language'],
  props: {
    id: {
      type: String,
      default: '1522770722245263361'
    },
    infos: {
      type: Object,
      default() {
        return {
          // 放弃报名提示
          giveupTip: ''
        };
      }
    },
    extendedInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      auditValue: undefined,
      timeValue: 0,
      siginup: {},
      data: {},
      points: {},
      info: {},
      size: 20,
      current: 1,
      list: [],
      total: 0,
      factor: 0,
      isShowAbandoner: true
    };
  },
  methods: {
    // 放弃报名
    cancel(id) {
      if (!this.factor) return;
      this.$parent.handleOpen({
        title: this.language().tit_give_up,
        type: 'cancel',
        width: 640,
        center: false,
        footer: true,
        cutline: false
      }, {
        giveupTip: this.infos.giveupTip || this.language().giveup_text,
        reason: ''
      }, () => {
        this.$parent.handleClose();
      }, async(data) => {
        const res = await this.siginup.cancel(id || this.info.id, {
          reason: data.reason
        });
        if (res.error) {
          this.$fmessage({ message: res.error.message, type: 'warning' });
        } else {
          this.$fmessage({ message: this.language().msg_give_up_success, type: 'success' });
          this.$parent.handleClose();
          this.search();
        }
      });
    },
    // 重置分页搜索
    searchPage() {
      this.current = 1;
      this.search();
    },
    // 搜索
    async search() {
      if (this.siginup) {
        if (this.data.userOtherEnrolled) {
          const res = await this.siginup.getOtherSignupList({
            auditStatus: this.auditValue,
            limit: this.size,
            offset: (this.current - 1) * this.size
          });
          this.$parent.fmessage(res);
          this.list = res.datas;
          this.isShowAbandoner = !!(res.datas.filter(item=>item.optGiveUpUserfullname).length);
          this.total = res.paging.count;
          this.size = res.paging.limit;
        } else {
          // 获取我的报名
          this.info = await this.siginup.getMySignup();
          this.$parent.fmessage(this.info);
        }
      }
    }
  },
  async created() {
    const SDK = this.$parent.SDK;
    // 注册项目
    this.siginup = new SDK(this.id);
    // 要素
    this.$parent.fmessage(await this.siginup.factorCheck(), ({result}) => {
      this.factor = result;
    });
    // 获取详情
    this.data = await SDK.getProjectDetail(this.id);
    this.$emit('callback', this.data);
    this.$parent.fmessage(this.data);
    // 获取积分
    this.points = await SDK.getCurrentUserPoints();
    this.$parent.fmessage(this.points);
    // 获取时间
    const systemTime = await SDK.getSystemTime();
    this.$parent.fmessage(systemTime);
    this.timeValue = parseInt(systemTime.data, 10);
    // 按钮控制
    const kongz = await this.siginup.getButtons(this.id);
    this.$parent.fmessage(kongz);
    this.data = {
      ...this.data,
      ...kongz
    };
    // 获取报名详情
    this.searchPage();
  }
};
</script>

<style lang="scss" scoped>
.yxtbiz-signup-my {
  display: flex;
  flex-direction: column;
}
</style>
